const CenterTypes = Object.freeze({
  Administrator: {
    id: 1,
    title: 'Administrator Center',
    name: 'AdminHome'
  },
  Teacher: {
    id: 2,
    title: 'Teacher Center',
    name: 'TeacherHome'
  },
  Student: {
    id: 3,
    title: 'Student Center',
    name: 'StudentHome'
  }
});

const DEFAULT_CENTER_ID = CenterTypes.Teacher.id;

const ALL_CENTER_IDS = Object.freeze(Object.values(CenterTypes).map((center) => center.id));

const isValidCenterId = (centerId) => ALL_CENTER_IDS.includes(centerId);

const getCenterById = (centerId) =>
  Object.values(CenterTypes).find((center) => center.id === centerId) || CenterTypes.Teacher;

export {
  CenterTypes,
  DEFAULT_CENTER_ID,
  isValidCenterId,
  getCenterById
};
